import { FC } from 'react'

import { FormDropdown } from 'cng-common/features/form'

import { HP_CONTACT_REQUEST_EDITOR_FORM } from '../../config'
import { useAssignmentPeriodCrud } from '../../model/useAssignementPeriodCrud'

interface IAssignmentPeriodDropdownProps {
  value: string
  disabled?: boolean
}

const validateAssignmentPeriod = (value: string) =>
  Promise.resolve(value ? '' : 'Please, select an assignment period')

export const AssignmentPeriodDropdown: FC<IAssignmentPeriodDropdownProps> = ({
  value,
  disabled,
}) => {
  const crudPeriod = useAssignmentPeriodCrud()

  return (
    <FormDropdown
      formKey={HP_CONTACT_REQUEST_EDITOR_FORM}
      field="AssignmentPeriod"
      label={'Assignment period'}
      defaultValue={value || ''}
      isRequired
      source={crudPeriod as any}
      caption="value"
      validateName="value"
      checkFn={validateAssignmentPeriod}
      disabled={disabled}
    />
  )
}
